export async function productionApi<T>(path: string, options?: RequestInit): Promise<T> {
  const response = await window.fetch(path, {
    credentials: "same-origin",
    headers: { "content-type": "application/json", ...(options?.headers ?? {}) },
    ...options
  });
  const payload = await response.json() as T & { error?: string };
  if (!response.ok) throw new Error(payload.error ?? "No se pudo completar la operación.");
  return payload;
}
